exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-listing-modal .modal-body {\n  background-color: #ECF0F1;\n}\n@media screen and (max-width: 768px) {\n.create-listing-modal .modal-content {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    border-radius: 0;\n}\n.create-listing-modal .modal-body {\n    position: fixed;\n    top: 81px;\n    height: calc(100vh - 81px);\n    left: 0;\n    right: 0;\n    bottom: 0;\n    overflow: scroll;\n    -webkit-overflow-scrolling: touch;\n}\n}", ""]);

// exports
